// The raised card of the redesigned screens (the project page, the project
// bank, expense tracking): the bank's card fill, a quiet
// hairline drawn on the card itself and a drop shadow behind it, in place of
// a bright outline. Each theme names the hairline and the shadow in
// theme.component.redesignRaisedCard; a theme without it falls back to the
// bank's flat card.

/**
 * The raised card's colours for the current theme.
 * @param {Object} theme MUI theme
 * @returns {{fill: string, edge: string, shadow: string}}
 */
export const getRaisedCardColors = (theme) => {
  const { redesignRaisedCard = {}, projectBankCard = {} } = theme.component;
  return {
    fill: redesignRaisedCard.backgroundColor || projectBankCard.backgroundColor,
    edge: redesignRaisedCard.borderColor || projectBankCard.borderColor,
    shadow: redesignRaisedCard.boxShadow || 'none',
  };
};

/**
 * The hairline as an inset ring (no size cost) together with the drop
 * shadow, as one box-shadow value. `extra` (another shadow) goes last.
 * @param {Object} theme MUI theme
 * @param {string} [extra]
 * @returns {string}
 */
export const raisedCardShadow = (theme, extra) => {
  const { edge, shadow } = getRaisedCardColors(theme);
  return [`inset 0 0 0 1px ${edge}`, shadow, extra]
    .filter((part) => part && part !== 'none')
    .join(', ');
};
